import { jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import styled, { css } from 'styled-components';
import { ICON_SIZE_MAP } from '../button/constants';
export const Link = ({ component, size = 'm', children, iconLeft, iconRight, ref, ...props }) => {
    return (_jsxs(Root, { as: component ?? 'a', size: size, ...props, ref: ref, children: [adjustLinkIcon(iconLeft, size), children, adjustLinkIcon(iconRight, size)] }));
};
// TODO: EMPORARY, WAIT FOR DESIGN
const Root = styled.a `
  color: ${(props) => props.theme.color.white[100]};
  display: flex;
  gap: 10px;
  cursor: pointer;

  ${({ size }) => {
    switch (size) {
        case 'l': {
            return css `
          font-size: 24px;
        `;
        }
        case 'm': {
            return css `
          font-size: 20px;
        `;
        }
        case 's': {
            return css `
          font-size: 18px;
        `;
        }
        case 'xs': {
            return css `
          font-size: 16px;
        `;
        }
    }
}}
`;
const adjustLinkIcon = (iconEl, size) => {
    if (!iconEl) {
        return;
    }
    const iconSize = ICON_SIZE_MAP[size];
    return React.cloneElement(iconEl, { size: iconSize });
};
//# sourceMappingURL=link.js.map